const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_id"];
const STORAGE_KEY = "utm_params";

export default defineNuxtPlugin(() => {
    const route = useRoute();

    const utmFromQuery = UTM_PARAMS.reduce(
        (acc, key) => {
            const value = route.query[key];
            if (typeof value === "string" && value.length > 0) {
                acc[key] = value;
            }
            return acc;
        },
        {} as Record<string, string>,
    );

    if (Object.keys(utmFromQuery).length > 0) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(utmFromQuery));
    }
});
